import FormFieldCheckbox from './FormFieldCheckbox.vue';
import FormFieldFriendlyCaptcha from './FormFieldFriendlyCaptcha.vue';
import FormFieldInput from './FormFieldInput.vue';
import FormFieldRadio from './FormFieldRadio.vue';
import FormFieldSelect from './FormFieldSelect.vue';
import { createFieldComponentResolver } from './fieldComponentResolver';

export const formFieldComponentResolver = createFieldComponentResolver();

formFieldComponentResolver.register('input', FormFieldInput);
formFieldComponentResolver.register('checkbox', FormFieldCheckbox);
formFieldComponentResolver.register('select', FormFieldSelect);
formFieldComponentResolver.register('radio', FormFieldRadio);
formFieldComponentResolver.register('textarea', FormFieldInput);
formFieldComponentResolver.register('hidden', FormFieldInput);
formFieldComponentResolver.register('friendlycaptcha', FormFieldFriendlyCaptcha);
